<div class="container">
    <div class="row">
        <div class="small edit-button">
            <div class="pe-4">
                <p>Password</p>
                <p>********</p>
            </div>
        </div>
        <div class="small ps-4"><a>Edit</a></div>
    </div>
</div>